module.exports = __webpack_public_path__ + "static/portfolio2b-6e4f04386c586cd0854f7b8c9d06374e.jpg";